import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: ["Linkin.bio", "linkinBio", "linkin bio"],
  iconColor: "#004F2D", // earth
  getIcon(options) {
    return createIcon(
      `
      <rect x="10.0522" y="7.97266" width="2.02664" height="7.99988" fill="black" />
      <rect
        x="16.0789"
        y="13.9463"
        width="2.02664"
        height="3.99994"
        transform="rotate(90 16.0789 13.9463)"
        fill="black"
      />
      <rect
        x="14.1055"
        y="11.9189"
        width="2.02589"
        height="2.02589"
        transform="rotate(90 14.1055 11.9189)"
        fill="#F18A65"
      />
      <rect
        x="16.0789"
        y="9.89258"
        width="2.02589"
        height="2.02589"
        transform="rotate(90 16.0789 9.89258)"
        fill="#64BB91"
      />
      <rect
        x="18.052"
        y="15.9736"
        width="2.02589"
        height="2.02589"
        transform="rotate(90 18.052 15.9736)"
        fill="#64BB91"
      />
      <rect
        x="12.0793"
        y="15.9736"
        width="2.02589"
        height="2.02589"
        transform="rotate(90 12.0793 15.9736)"
        fill="#42C0F0"
      />
      <rect
        x="10.0522"
        y="11.9727"
        width="2.02589"
        height="2.02589"
        transform="rotate(90 10.0522 11.9727)"
        fill="#5D5CA6"
      />
      <rect
        x="8.02588"
        y="9.94727"
        width="2.02589"
        height="2.02589"
        transform="rotate(90 8.02588 9.94727)"
        fill="#42C0F0"
      />
      <rect
        x="10.0522"
        y="6"
        width="2.02589"
        height="2.02589"
        transform="rotate(90 10.0522 6)"
        fill="#FAB316"
      />
      `,
      "#E5EDEA", // earth-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
